import CybersecurityAwarenessMonthPage from '@/components/CybersecurityAwarenessMonthPage';
import type { Route } from './+types/home';

export function meta({}: Route.MetaArgs) {
  return [
    { title: '$1,000 Secure Coding Credit | Simulations Labs' },
    {
      name: 'description',
      content:
        'Get $1,000 in Simulations Labs credit to train your developers on real vulnerabilities. Run secure coding competitions, assess developer skills, and build secure coding habits through hands-on simulations.',
    },
  ];
}

export default function CybersecurityAwarenessMonth() {
  return <CybersecurityAwarenessMonthPage />;
}
